import styled from 'styled-components';

const HeaderContent = styled.div`
    padding: 4rem 0 3rem 0;
    border-bottom: 0.1rem solid ${props => props.theme.colors.border};
    background-color: ${props => props.theme.colors.subtle.light};
`;

export default HeaderContent;
